// Auto-generated by splitter.py — do not regenerate; edit directly.

import React from 'react';
import { Check, ChevronLeft } from 'lucide-react';

export const WizardSteps = ({ steps, current }) => (
  <div className="flex items-center gap-0 border-b border-[#EEEDEA] -mx-5 px-5 pb-0 mb-4">
    {steps.map((s, i) => {
      const active = s.id === current;
      const done = steps.findIndex(x => x.id === current) > i;
      return (
        <div key={s.id} className={`px-3 py-2 text-[11.5px] font-medium border-b-2 inline-flex items-center gap-1.5 ${active ? 'border-[#1F2937] text-[#1F2937]' : done ? 'border-transparent text-[#1F6A3A]' : 'border-transparent text-[#9CA3AF]'}`}>
          {done && <Check className="w-3 h-3" strokeWidth={2.5} />}
          <span>{i + 1}. {s.label}</span>
        </div>
      );
    })}
  </div>
);

// ---- WizardFooter — shared back/cancel/continue/confirm bar

export const WizardFooter = ({ onBack, onCancel, onNext, nextLabel = 'Continue', nextDisabled, primaryIcon: Icon }) => (
  <div className="px-5 py-3 border-t border-[#EEEDEA] bg-[#FBFAF7] -mx-5 -mb-4 mt-4 flex items-center justify-between">
    {onBack ? <button onClick={onBack} className="h-8 px-3 text-[12px] font-medium rounded-md text-[#1F2937] hover:bg-[#F2F1ED] inline-flex items-center gap-1.5"><ChevronLeft className="w-3.5 h-3.5" />Back</button> : <div />}
    <div className="flex items-center gap-2">
      <button onClick={onCancel} className="h-8 px-3 text-[12px] font-medium rounded-md text-[#1F2937] hover:bg-[#F2F1ED]">Cancel</button>
      <button onClick={onNext} disabled={nextDisabled} className="h-8 px-3 text-[12px] font-medium rounded-md bg-[#1F2937] hover:bg-[#111827] disabled:bg-[#9CA3AF] disabled:cursor-not-allowed text-white inline-flex items-center gap-1.5">
        {Icon && <Icon className="w-3.5 h-3.5" />}{nextLabel}
      </button>
    </div>
  </div>
);

/* ----------------------------------------------------------------------------
   MANUAL ORDER WIZARD
   ---------------------------------------------------------------------------- */

